export const ListQueryKey = 'diceConfigs';
export const DetailQueryKey = 'diceConfig';

export const Urls = {
  selectUrl: '/dice/list',
  updateUrl: '/dice/update',
  deleteUrl: '/dice/delete',
  createUrl: '/dice/create',
  detailUrl: '/dice/detail',
};
